import { QUES_COMPONENT_TYPES } from '../componentTypes';

export default [
  {
    sequenceNumber: 15,
    subTitle: 'Anticipated Change for New Organization',
    content:
      "What is the anticipated change to the new organization's operating model?",
    subSection: 'Operating Model',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 3,
      extremeTexts: ['Minimal Change', 'Moderate Change', 'Significant Change'],
    },
    isStrategyCollapse: true,
  },
  {
    sequenceNumber: 16,
    subTitle: 'IT Operating Model',
    content:
      'How is the IT / Systems operating model (e.g., core ERP / Cloud systems, digital / analytics capabilities, cyber, etc.) expected to change?',
    subSection: 'IT Systems',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 3,
      extremeTexts: ['Minimal Change', 'Moderate Change', 'Significant Change'],
    },
  },
  {
    sequenceNumber: 17,
    subTitle: 'Route to Market',
    content:
      "Is the Buyer expected to change its route-to-market model / strategy to accommodate for the Target's?",
    subSection: 'Operating Model',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: "Hybrid with Target's model" },
      { text: "Adopt Target's model" },
      { text: "No change to Buyer's model" },
    ],
  },
  {
    sequenceNumber: 18,
    subTitle: 'Customer Support Model',
    content:
      "Is the Buyer expected to change its customer support model to accommodate for the Target's?",
    subSection: 'Operating Model',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [
      { text: "Hybrid with Target's model" },
      { text: "Adopt Target's model" },
      { text: "No change to Buyer's model" },
    ],
  },
  {
    sequenceNumber: 19,
    subTitle: 'Geographical Footprint',
    content:
      'Is the deal domestic or is there a Cross-Border / International element?',
    subSection: 'Geography',
    type: QUES_COMPONENT_TYPES.RADIO,
    options: [{ text: 'Cross-Border / International' }, { text: 'Domestic' }],
  },
  {
    sequenceNumber: 20,
    subTitle: 'Expected Legal Entity Reorganization',
    content:
      'What is the expected extent and impact of Legal Entity reorganization?',
    subSection: 'Operating Model',
    type: QUES_COMPONENT_TYPES.SCALE,
    options: {
      count: 5,
      extremeTexts: [
        'Minimal Impact',
        'Minor Impact',
        'Moderate Impact',
        'Major Impact',
        'Significant Impact',
      ],
    },
  },
];
